<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading }">
    <panel>
      <template #title>
        <div>
          Текущие показатели
        </div>
      </template>
      <template #content>
        <div class="layout">
          <text-card v-for="(measure, index) in getStats(loading)" :key="index" :loading="loading">
            <template #title>{{ measure.title }}</template>
            <template #value>{{ measure.value }}</template>
            <template #unit>{{ measure.unit }}</template>
          </text-card>
        </div>
      </template>
    </panel>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import Panel from '@/components/dashboard/widgets/templates/Panel.vue'
import TextCard from '@/components/dashboard/widgets/templates/TextCard.vue'
import { pluralForm } from '@/utils/pluralForms'

export default {
  components: {
    ReportDataProvider,
    Panel,
    TextCard
  },
  data () {
    return {
      requiredReports: ['tendersCountPercent'],
      reports: []
    }
  },
  computed: {
    stats () {
      return [
        {
          title: 'C победителем',
          value: this.reports.tendersCountPercent.withWinner,
          unit: pluralForm(this.reports.tendersCountPercent.withWinner, ['конкурс', 'конкурса', 'конкурсов']),
          prompt: 'Количество конкурсов, закрытых с победителем;'
        },
        {
          title: 'Незавершенные',
          value: this.reports.tendersCountPercent.incomplete,
          unit: pluralForm(this.reports.tendersCountPercent.incomplete, ['конкурс', 'конкурса', 'конкурсов']),
          prompt: 'Количество конкурсов на стадии "Согласование"'
        },
        {
          title: 'Несостоявшиеся',
          value: this.reports.tendersCountPercent.canceled,
          unit: pluralForm(this.reports.tendersCountPercent.canceled, ['конкурс', 'конкурса', 'конкурсов']),
          prompt: 'Количество конкурсов, закрытых без победителя и отмененных'
        }
      ]
    }
  },
  methods: {
    getStats (loading) {
      return loading ? [{}, {}, {}] : this.stats
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: .5rem;
}
</style>
